//TODO: Usage of this can be replaced with the LocalizedCurrency component
export default function setPriceWithCurrency(num, culture) {
    const options = { style: 'currency', currency: culture.currency };
    const numberFormat = new Intl.NumberFormat(culture.cultureInfo, options);
    return numberFormat.format(num);
}